module.exports = __webpack_public_path__ + "img/BACK_MOBILE.9afaf1b3.png";